<button mat-menu-item [routerLink]="['/change-password']">{{translate.instant('changePassword.btnMsg')}}</button>
<button mat-menu-item (click)="logout()">{{translate.instant('component.header.navBarItems.logout')}}</button>
